console.log('Vite ⚡️ Rails')

import '@hotwired/turbo-rails'
import '~/turbo_stream_actions'
import '~/controllers'
import 'choices.js/public/assets/styles/choices.min.css'
import 'cally'
